<h2 mat-dialog-title>Select tag</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Tag</mat-label>
    <mat-select [value]="selectedTagId" (selectionChange)="selectedTagId = $event.value">
      @for (tag of data.tags; track tag.TagId) {
        <mat-option [value]="tag.TagId">{{ tag.Text || tag.TagText }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (!data.tags || data.tags.length === 0) {
    <div style="color: gray;">No available tags to add.</div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">CANCEL</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="!selectedTagId">ADD</button>
</mat-dialog-actions>
